// generic string functions
String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

if (typeof String.prototype.startsWith != 'function') {
	  // see below for better implementation!
	  String.prototype.startsWith = function (str){
	    return this.indexOf(str) == 0;
	  };
}

String.prototype.reverse = function() {
	return this.split("").reverse().join("");
}

String.prototype.getHash = function() {
	var shaObj = new jsSHA("SHA-512", "TEXT");
	shaObj.update(this);
	var hash = shaObj.getHash("HEX");
	return hash;
};

if (typeof String.prototype.isNullOrWhiteSpace != 'function') {
	String.prototype.isNullOrWhiteSpace = function() {
		return this === null || this.match(/^ *$/) !== null || this.match(/^\s*$/) !== null;
	}
}

String.prototype.elipsis = function(charNo) {
	return this.length > charNo ?  this.substring(0,charNo) + "..." : this;   
};

